import { Button } from './ui/button'
import { Field, FieldDescription, FieldLabel } from './ui/field'
import { useFieldContext } from '@/lib/form'

// Couldn't think of a better name for this but it's a list of buttons that you can "switch" between.
export function SwitchButtons({
  label,
  description,
  htmlFor,
  options,
}: {
  label: string
  description: string
  htmlFor: string
  options: Array<{ label: string; value: string }>
}) {
  const field = useFieldContext<string>()

  return (
    <Field>
      <div>
        <FieldLabel htmlFor={htmlFor}>{label}</FieldLabel>
        {description && <FieldDescription>{description}</FieldDescription>}
      </div>
      <div className="space-x-2">
        {options.map((option) => (
          <Button
            type="button"
            variant={field.state.value === option.value ? 'steel' : 'outline'}
            className="text-xs"
            onClick={() => field.handleChange(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </Field>
  )
}
